import React from 'react';

// Shown in place of a missing poster/graphic: a faded VideBits logo watermark
// on the card's neutral background. Scales to its container (cards and the
// larger detail poster) and stays subtle so it reads as a placeholder.
export default function PosterPlaceholder({ className = '' }) {
  return (
    <div className={`w-full h-full flex items-center justify-center ${className}`}>
      <img
        src="/logo-transparent.svg"
        alt=""
        aria-hidden="true"
        className="w-1/2 max-w-[72px] opacity-20"
      />
    </div>
  );
}
